export const downloadCsv = (fileName, CSV) => {
  var csvData = new Blob([CSV], { type: 'text/csv' }); //new way
  var csvUrl = URL.createObjectURL(csvData);

  var link = document.createElement("a");
  link.href = csvUrl;

  link.style = "visibility:hidden";
  link.download = fileName + ".csv";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const jsonToCSVConvertor = (JSONData, ReportTitle, ShowLabel, fileName, heading, fullHeader) => {
  var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

  var CSV = "";
  let headers = "";

  if (!fullHeader) {
    if (ShowLabel) {
      var row = "";

      for (var index in arrData[0]) {
        row += index + ',';
      }

      row = row.slice(0, -1);

      CSV += row + '\r\n';
    } else {
      if (heading)
        CSV += heading;
    }
  }

  for (var i = 0; i < arrData.length; i++) {
    var row = "";
    let rowHeaders = "";

    for (var index in arrData[i]) {
      if (fullHeader) rowHeaders += index + ",";
      row += '"' + arrData[i][index] + '",';
    }

    row.slice(0, row.length - 1);
    CSV += row + '\r\n';

    if (fullHeader && (rowHeaders.length > headers.length)) headers = rowHeaders;
  }

  if (CSV == '') {
    alert("Invalid data");
    return;
  }

  if (fullHeader) CSV = headers + "\r\n" + CSV;

  fileName = fileName || "UnnamedFile";
  fileName += ReportTitle.replace(/ /g, "_");

  downloadCsv(fileName, CSV);
}

export const handleReportDownload = (data) => {
  var sendToExcel = data.map(a => Object.assign({}, a));
  sendToExcel.forEach((ping) => {
    ping["Sr No"] = ping.idx;
    ping["Date"] = `${ping.date || ""} ${ping.time || ""}` || "-";
    ping["Speed"] = ping.speed || "-";
    ping["Distance (kms)"] = (ping.distance || ping.distance === 0) ? ping.distance.toFixed(5) : "-";
    ping["Total Distance (kms)"] = (ping.totalDistance || ping.totalDistance === 0) ? ping.totalDistance.toFixed(5) : "-";
    ping["Latitude"] = ping.lat ? ping.lat.toFixed(5) : "-";
    ping["Longitude"] = ping.lng ? ping.lng.toFixed(5) : "-";
  });

  var sendData = sendToExcel.map(function (exceldata) {
    var args = "Sr No, Date, Speed, Distance (kms), Total Distance (kms), Latitude, Longitude";
    var filteredData = args.split(",").reduce((mem, arg) => {
      arg = arg.trim();
      mem[arg] = exceldata[arg];
      return mem;
    }, {});
    return filteredData;
  });
  if (sendData.length) jsonToCSVConvertor(sendData, "", true, "Ride_Report_" + Date.now(), false);
}